import Helpers from "./helpers";

declare var Mustache: any;
declare var popups: any;

export default class DeliveryChecker {

	private deliveryCheckerElements = document.querySelectorAll('.mDeliveryChecker');

	constructor() {

		if (!this.deliveryCheckerElements.length) {
			return;
		}

		this.attachEvents();

	}

	private attachEvents() {
		const self = this;
		Helpers.scopedLoop(this.deliveryCheckerElements, function (deliveryCheckerElement: HTMLElement, i: Number, context: any) {

			const inputElement = deliveryCheckerElement.querySelector('.js-input') as HTMLInputElement;
			const buttonElement = deliveryCheckerElement.querySelector('.js-button') as HTMLButtonElement;
			const buttonText = buttonElement.textContent;

			buttonElement.addEventListener('click', (e: Event) => {
				self.lookup(deliveryCheckerElement, inputElement, buttonElement, buttonText);
				e.preventDefault();
			});

			inputElement.addEventListener('keydown', (e: KeyboardEvent) => {
				const key = Helpers.getKeypressed(e);
				const isEnterKey = key === 'Enter' || key === 13;
				if (isEnterKey) {
					self.lookup(deliveryCheckerElement, inputElement, buttonElement, buttonText);
					e.preventDefault();
				}

			});

		}, this);
	}

	private lookup(
		deliveryCheckerElement: HTMLElement,
		inputElement: HTMLInputElement,
		buttonElement: HTMLButtonElement,
		buttonText: string) {

		buttonElement.setAttribute('disabled', 'disabled');
		buttonElement.textContent = 'Checking...';

		const template = document.getElementById('deliveryCheckerResultsTemplate').innerHTML;
		Mustache.parse(template);
      
		const productData = this.getProductData(inputElement) as string;

		fetch(
			'/deliveryquotes/json', {
			method: 'POST',
			body: productData,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			}
		})
			.then((response: any)=> {
				if (response.ok) {
					return response.json();
				}
				else {
					throw new Error(response as any);
				}
			})
			.then((response: any) => {
				const resultsContainerElement = deliveryCheckerElement.querySelector('.js-results') as HTMLDivElement;
				resultsContainerElement.style.display = 'block';
				resultsContainerElement.innerHTML = Mustache.render(template, response);
				this.resetButton(buttonElement, buttonText);
			})
			.catch(() => {
				popups.confirm('Error', 'Sorry, there was an error. Please try again.', '?', true);
				this.resetButton(buttonElement, buttonText);
			});

	}

	private getProductData(inputElement: HTMLInputElement) {
		const formElement = inputElement.closest('form') || document.querySelector('.js-product-page-form');
		let serializedProductData = Helpers.serialize(formElement);
		// On the B product test the postcode is in a different form from the product
		if (serializedProductData.indexOf('postcode') === -1) {
			serializedProductData += `&postcode=${inputElement.value}`;
		}
		return serializedProductData;
	}

	private resetButton(buttonElement: HTMLElement, buttonText: string) {
		buttonElement.removeAttribute('disabled');
		buttonElement.textContent = buttonText;
	}

}
